import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import Loader from "react-loader-spinner";
import { Modal } from 'reactstrap';
import "./loader.css";

const loaderStyle = {
  position: 'absolute',
  top: '42%',
  width: '10%',
  marginLeft: '45%',
  marginRight: '45%',
  height: 'auto',
  textAlign: 'center'
}


export default () => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress && (
      <Modal className="custom-loader" isOpen={promiseInProgress} fade={false} style={loaderStyle}>
        <Loader type="Bars" color="#ffffff" />
      </Modal >
    )
  );
};